import React from 'react';
import { createComponent } from '@lit-labs/react';

import Dsy from './dsyui';

const LitComp = Dsy.components.DsyInputNumber;

export const DsyInputNumber = createComponent(
  React,
  'dsy-input-number',
  LitComp,
  {},
);

export default DsyInputNumber;
